import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const userGroupsAdapter = getAdapter();

const userGroupsSlice = createSlice({
  name: 'userGroups',
  initialState: userGroupsAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setUserGroups: (state, { payload: { userGroups, source } }) => {
      userGroupsAdapter.setAll(state, userGroups);
      state.source = source;
    },
  },
});

const selectors = userGroupsAdapter.getSelectors(({ userGroups }) => userGroups);

export const getUserGroups = (state) => selectors.selectAll(state);

export const { setUserGroups } = userGroupsSlice.actions;

export default userGroupsSlice.reducer;
